import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-methods-images',
  templateUrl: './payment-methods.component.html',
  styleUrls: ['./payment-methods.component.css']
})
export class PaymentMethodsComponent
{ }
